import About from "./about";

function page(){
    return(
        <About/>
    );
};
export default page;